export class LoanApplicationTagsApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getLoanTags({ companyId, ...params }) {
    return this.#http.get(`/api/companies/${companyId}/tags`, {
      params,
    });
  }
}
